import { http } from "./http";

export type MarketingPixelsConfig = {
  establishmentId?: string;
  meta: {
    enabled: boolean;
    pixelId: string;
  };
  ga4: {
    enabled: boolean;
    measurementId: string;
  };
  googleAds: {
    enabled: boolean;
    conversionId: string;
    conversionLabel: string;
  };
  updatedAt?: string | null;
};

export type MarketingPixelsPayload = {
  metaEnabled: boolean;
  metaPixelId?: string | null;
  ga4Enabled: boolean;
  ga4MeasurementId?: string | null;
  googleAdsEnabled: boolean;
  googleAdsConversionId?: string | null;
  googleAdsConversionLabel?: string | null;
};

export const emptyMarketingPixelsConfig: MarketingPixelsConfig = {
  meta: { enabled: false, pixelId: "" },
  ga4: { enabled: false, measurementId: "" },
  googleAds: { enabled: false, conversionId: "", conversionLabel: "" },
  updatedAt: null,
};

export async function getMarketingPixelsConfig(establishmentId: string, token: string) {
  return http<MarketingPixelsConfig>(
    `/establishments/${establishmentId}/marketing-pixels`,
    {
      token,
    }
  );
}

export async function updateMarketingPixelsConfig(
  establishmentId: string,
  token: string,
  payload: MarketingPixelsPayload
) {
  return http<MarketingPixelsConfig>(
    `/establishments/${establishmentId}/marketing-pixels`,
    {
      method: "PUT",
      token,
      body: payload,
    }
  );
}

export async function sendMarketingPixelsTestEvent(
  establishmentId: string,
  token: string
) {
  return http<{
    ok: true;
    eventName: string;
    message: string;
    payload: Record<string, unknown>;
    config: Omit<MarketingPixelsConfig, "establishmentId" | "updatedAt">;
  }>(`/establishments/${establishmentId}/marketing-pixels/test-event`, {
    method: "POST",
    token,
  });
}

export async function getPublicMarketingPixelsConfig(slug: string) {
  return http<Omit<MarketingPixelsConfig, "establishmentId" | "updatedAt">>(
    `/public/${slug}/marketing-pixels`
  );
}
